import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useNavigate } from "react-router-dom";

import ContentCard from "../../../components/misc/ContentCard";
import DatePicker from "../../../components/misc/DatePicker";
import moment from "moment";
import FormButtons from "../../../components/misc/FormButtons";
import {
  fetchDownloadTemperatureChart,
  fetchDownloadTemperatureChartForNodes,
} from "../../../redux/api/raports.api";
import { getWorkingRoutesNodes } from "../../../redux/api/expedition.api";

import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";
import { dateForDatabase } from "../../../utils/dateAndTime";
import Dropdown, { DropdownValue } from "../../../components/misc/Dropdown";

function NodeTemperatureChart() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    expedition: {
      workingRoutesNodes: {
        data: { data: workingNodes },
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(
      getWorkingRoutesNodes({
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  const today = moment().format("YYYY-MM-DD");

  const [isLoading, setIsLoading] = useState(false);
  const [transportDay, setTransportDay] = useState<Date | null>(
    new Date(today),
  );
  const [selectedNodes, setSelectedNodes] = useState<DropdownValue[]>([]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDownloadTemperatureChart = async () => {
    if (!selectedNodes.length) {
      return;
    }

    setIsLoading(true);

    const resultAction = await dispatch(
      fetchDownloadTemperatureChartForNodes({
        nodes: selectedNodes,
        dataCursa: dateForDatabase(transportDay),
      }),
    );

    if (
      checkEndpointStatus(resultAction, fetchDownloadTemperatureChart) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, fetchDownloadTemperatureChart) ===
      endpointStatus.fulfilled
    ) {
      setSelectedNodes([]);
    }
  };

  const fleetNomenclaturesDropdownValues = useMemo(
    () =>
      workingNodes?.map((item) => ({
        label: item.nodNume,
        id: item.id_nod,
      })),
    [workingNodes],
  );

  const disableSubmit =
    !selectedNodes.length ||
    selectedNodes.some(({ label }) => {
      const nrAutoLength = label?.toString().length;

      return !nrAutoLength;
    });

  return (
    <ContentCard
      cardTitle={"Descarca diagrama de temperatura noduri"}
      cardHeaderClassName="text-center"
      isLoading={isLoading}>
      <>
        <Dropdown
          className="my-4"
          title={"Selecteaza nodurile"}
          data={fleetNomenclaturesDropdownValues}
          multipleValues={selectedNodes}
          setMultipleValues={setSelectedNodes}
        />

        <DatePicker
          label="Selecteaza ziua"
          maxDate={new Date()}
          value={transportDay}
          handleChangeDate={(value) => setTransportDay(value)}
        />
      </>

      <FormButtons
        goBackLabel="Inapoi"
        goNextLabel="Descarca diagrama"
        nextButtonVariant="action"
        nextButtonIcon="DOWNLOAD"
        nextButtonDisabled={disableSubmit}
        handleGoBack={handleGoBack}
        handleGoNext={handleDownloadTemperatureChart}
      />
    </ContentCard>
  );
}

export default NodeTemperatureChart;
